import React, { useMemo, useState } from 'react';
import { useCallback } from 'react';
import i18n from '@sprinklr/display-builder/i18n';

// types
import { TimeDurationTunableProps } from './types';

// components
import { Flexbox, IconButton, Input, Popover } from 'components/spaceKit';

// const
import { timeIntervals } from 'components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';
import { StyledForm, StyledInputWrap, StyledSelect } from './styledComponents';
import { useTimeDurationTunable } from './hooks/useTimeDurationTunable';

function TimeDurationTunable({ tag, onFormSubmit }: TimeDurationTunableProps) {
    const duration = tag.value;
    const {
        handleCancel,
        handleConfirm,
        handleUpdateDuration,
        removeItem,
        handleUpdateTimeInterval,
        handleAddItem,
        durationText,
        isOpen,
        setIsOpen,
        formState,
    } = useTimeDurationTunable({ tag, onFormSubmit });

    return (
        <>
            <Popover
                formControl={{
                    primary: {
                        text: i18n.t('Confirm'),
                        canClick: true,
                        onClick: handleConfirm,
                    },
                    secondary: {
                        text: i18n.t('Cancel'),
                        canClick: true,
                        onClick: handleCancel,
                    },
                }}
                pad={false}
                position='bottom'
                isOpen={isOpen}
                onClickOutside={handleConfirm}
                popoverContents={
                    <StyledForm vertical gap>
                        {formState.map((formItem, index) => (
                            <Flexbox key={index} gap middle>
                                <StyledInputWrap>
                                    <Input
                                        onChange={() => handleUpdateDuration(event, index)}
                                        type='number'
                                        placeholder={i18n.t('Value')}
                                        value={formItem.value}
                                        min={0}
                                    />
                                </StyledInputWrap>
                                <StyledSelect
                                    placeholder='interval'
                                    options={timeIntervals}
                                    value={formItem.interval}
                                    onChange={event => handleUpdateTimeInterval(event, index)}
                                />
                                {index > 0 || formState.length > 1 ? (
                                    <IconButton
                                        icon='icon-minus'
                                        onClick={() => removeItem(index)}
                                    />
                                ) : null}
                                {formState.length - 1 === index ? (
                                    <IconButton icon='icon-plus' onClick={handleAddItem} />
                                ) : null}
                            </Flexbox>
                        ))}
                    </StyledForm>
                }>
                <Flexbox onClick={() => setIsOpen(prev => !prev)}>
                    {!duration ? (
                        <Input placeholder={i18n.t('Choose Duration')} />
                    ) : (
                        <Input placeholder={i18n.t('Value')} value={durationText} />
                    )}
                </Flexbox>
            </Popover>
        </>
    );
}

export { TimeDurationTunable };
